import GameObject from '../../../GameObject/GameObject';
import AnimationClip, { AnimationClipEvent } from '../AnimationClip';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import { delay } from '../../../Utility/Task/TaskQueue';
import SpriteComponent from '../../../Component/Render/Sprite';
import TransformComponent from '../../../Component/Transform';
import Scene from '../../../Scene/Scene';
import { StopAnimation } from '../AnimationHelper';
import { Random } from '../../../Utility/Random';
import { Easing } from '@tweenjs/tween.js';

interface ICardIceBreakMeta {
    scene: Scene;
    cardScore: number;
    discard: BaseCard;
}

export class CardIceBreak extends AnimationClip<ICardIceBreakMeta> {
    public *execute(
        card: GameObject,
        meta: ICardIceBreakMeta
    ): IterableIterator<number> {
        /*const transform = card.getComponent(TransformComponent);
        const tween = this.getTween(transform.scale);
        tween.to({x:0.75, y:0.75}, 200);
        tween.*/

        StopAnimation(meta.discard);

        meta.discard.getComponent(TransformComponent).position.set(0, 0);
        meta.discard.getComponent(TransformComponent).rotation = 0;
        meta.discard.getComponent(TransformComponent).scale.set(1, 1);

        this.cardFlip(meta.discard);

        yield* this.iceBreakFrameByFrame(card);

        const transform = card.getComponent(TransformComponent);

        meta.scene.emit('UpdateScoreProgress');
    }

    private *iceBreakFrameByFrame(card: GameObject) {
        const frames = [
            //'Ice_card',
            'ice_1',
            'ice_2',
            'ice_3',
            'ice_4',
            'ice_5',
            'ice_6',
            'ice_7',
            'ice_8',
        ];
        const yPositions = [0, 0, 8, 22, 52];

        const sprite = card.find('modifierContainer/ice/iceSprite');

        const iceSprite = sprite.getComponent(SpriteComponent);
        const iceTransform = sprite.getComponent(TransformComponent);

        this.on(AnimationClipEvent.DESTROY, () => {
            iceSprite.visible = false;
        });

        const fps = 24;
        const msPerFrame = 2000 / fps;
        let currentFrame = 0;
        while (currentFrame < frames.length) {
            iceTransform.position.y = yPositions[currentFrame];
            iceSprite.texture = frames[currentFrame];
            currentFrame++;
            yield* delay(msPerFrame);
        }

        iceSprite.visible = false;
    }

    private cardFlip(card: BaseCard) {
        const cardTransform = card.getComponent(TransformComponent);
        const tweenX = this.getTween(cardTransform.position);
        const tweenY = this.getTween(cardTransform.position);
        const tweenRotation = this.getTween(cardTransform);

        tweenX.to({ x: cardTransform.x + Random.int(50, 150) }, 750);
        tweenX.start(this.elapsedTime);

        tweenY.to({ y: -150 }, 250);
        tweenY.start(this.elapsedTime);
        tweenY.easing(Easing.Quadratic.Out);
        tweenY.onComplete(() => {
            const tweenYOut = this.getTween(cardTransform.position);
            tweenYOut.to({ y: 450 }, 500);
            tweenYOut.easing(Easing.Quadratic.In);
            tweenYOut.start(this.elapsedTime);
        });

        tweenRotation.to({ rotation: Math.PI * 2 }, 750);
        tweenRotation.start(this.elapsedTime);

        this.on(AnimationClipEvent.DESTROY, () => {
            tweenX.end();
            tweenY.end();
            tweenRotation.end();
            cardTransform.y = 450;
        });
    }
}
